import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axiosInstance from "../../api";
import { useOktaAuth } from "@okta/okta-react";
import InfoSliderResponse from "../../models/API/responseModels/InfoSliderResponse.model";
import { useEffect } from "react";

function useInfoSlider(): UseQueryResult<InfoSliderResponse> {
  const authState = useOktaAuth()?.authState;
  // useEffect(() => {}, [infoQuery]);

  return useQuery({
    queryKey: ["infoSlider"],
    queryFn: () => {
      return axiosInstance
        .get(`v1/info-section/`, {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        })
        .then((res) => res.data);
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: !!authState?.accessToken?.accessToken,
  });
}

export default useInfoSlider;
